import { push } from "connected-react-router";
import { put, takeEvery } from "redux-saga/effects";

import { APP_STATUS_INCOMPLETE } from "stentor-models";

import { loading } from "layouts/AppLayout/modules";
import { ClientApp } from "models";
import { getApi } from "../../../sagas";
import { CREATE_APP, CreateAppAction, createAppEnd } from "../actions";

export function* createApp(action: CreateAppAction) {
    const { payload } = action;

    const api = getApi(payload);

    try {
        yield put(loading(true, action));
        // @ts-ignore yields generate implicit anys as of TS 4.2
        const app = yield api.createApp(action.payload.app);
        // Set the state on the newly created app to incomplete
        // TODO: eventually move this to the server
        const incompleteApp: ClientApp = {
            ...app,
            status: {
                email: "",
                notes: "",
                timestamp: Date.now(),
                type: APP_STATUS_INCOMPLETE
            }
        };

        const appRedictPath = `/${app.organizationId}/${app.appId}`;

        yield put(createAppEnd(undefined, incompleteApp));
        yield put(push(appRedictPath));
    } catch (e) {
        yield put(createAppEnd(e));
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchCreateApp() {
    yield takeEvery(CREATE_APP, createApp);
}
